import {useContext} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import {OrderAuditContext} from '../../context'
import {SectionForm} from '../../../../components/SectionForm'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {orderAuditArchivedNoteModalSchema} from '../../validations'

const OrderAuditArchivedNoteModal = ({row, onClose}: any) => {
  const {onUpdateStatus, isOperationLoading, isLoading} = useContext(OrderAuditContext)

  const defaultValues: any = {
    note: '',
  }

  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm({
    defaultValues,
    resolver: yupResolver(orderAuditArchivedNoteModalSchema),
  })

  const onChangeStatus = async (data: any) => {
    const payload = {
      is_archived: true,
      note: data.note,
    }
    onUpdateStatus(row?.order_id, payload)
  }

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      onAction={handleSubmit(onChangeStatus)}
      actionName='Archive'
      isOperationLoading={isOperationLoading}
      isDataLoading={isLoading}
      title='Archive note'
      body={
        <>
          <p className='mb-10'>Please provide the note for archiving this Order.</p>
          <SectionForm
            id='order-audit-archived-note-form'
            register={register}
            errors={errors}
            inputs={[
              {
                id: 'note',
                label: 'Note',
                isTextArea: true,
                registerKey: 'note',
                isRequired: true,
                maxLength: 155,
              },
            ]}
          />
        </>
      }
    />
  )
}

export default OrderAuditArchivedNoteModal
